<!-- Kendo fixes a card at 285px unless it is told otherwise; this one spans the answer. -->
<kendo-card width="100%">
  <kendo-card-body>
    <div class="flex items-start gap-3">
      <!-- Decorative: the name beside it already says who this is. -->
      <span
        class="ai-profile-avatar flex items-center justify-center shrink-0 w-10 h-10 rounded-full bg-bush-green-140 text-primary-100 subtitle-1 bg-cover bg-center"
        aria-hidden="true"
        [style.background-image]="photo() || null"
      >
        @if (!photo()) {
          @if (initials(); as initials) {
            {{ initials }}
          } @else {
            <span class="fa-icons icon-solid icon-user icon-16"></span>
          }
        }
      </span>

      <div class="flex-1 min-w-0">
        <!-- The badge ends the name's row, and drops under the name when the two do not fit. -->
        <div class="flex flex-wrap items-start justify-between gap-x-3 gap-y-1">
          <h4 class="subtitle-1 text-black m-0">{{ profile().name }}</h4>

          @if (badge(); as badge) {
            <ai-answer-chip-list [chipList]="badge"></ai-answer-chip-list>
          }
        </div>

        <!-- No <p> inside the card: Kendo's `.k-card-body p` margins outrank the spacing classes. -->
        @if (profile().subtitle; as subtitle) {
          <div class="text-caption text-neutral-80 mt-0.5">{{ subtitle }}</div>
        }

        <!-- A fact stays whole and carries the dot after it, so a narrow panel breaks the line
             between facts and never starts one with a dot. -->
        @if (profile().details.length) {
          <ul class="list-none text-caption text-neutral-70 mt-0.5 mb-0 p-0">
            @for (detail of profile().details; track $index) {
              <li class="inline-block">
                {{ detail }}@if (!$last) {<span class="mx-1.5" aria-hidden="true">·</span>}
              </li>
            }
          </ul>
        }
      </div>
    </div>

    @if (profile().chips; as chips) {
      <ai-answer-chip-list class="mt-3" [chipList]="chips"></ai-answer-chip-list>
    }

    @if (profile().description; as description) {
      <div class="text-body-2 text-neutral-90 mt-3">{{ description }}</div>
    }
  </kendo-card-body>
</kendo-card>
